<template>
  <div class="d-flex align-items-end dotted-row">
    <span class="label text-left break-all"><slot name="pre-label"/>{{ label }}</span>
    <span class="dots"></span>
    <span class="value">{{ value }}</span>
  </div>
</template>

<script setup>
defineProps({
  label: {
    type: String,
  },
  value: {
    type: String,
  }
})
</script>

<style scoped lang="scss">
.dotted-row {
  margin: 3px 0;
  color: $gray-text2;
  &.total {
    font-size: 19px;
    font-weight: bold;
    color: #000;
  }
  &.black {
    color: #000;
    font-weight: bold;
  }
  .dots {
    flex: 1;
    border-bottom: 1px dashed $border-new-color;
    margin: 0 10px 4px;
    min-width: 24px;
  }
  .value {
    white-space: nowrap;
  }
}
@media screen and (max-width: 768px) {
  .dotted-row {
    &.total {
      font-size: 17px;
    }
  }
}
</style>
